import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { HealthcareProfessionalsApi } from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import { HealthcareProfessional, IHealthcareProfessional } from '../HealthcareProfessional.ts';

export function useGetHealthcareProfessionals() {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.healthcareProfessionals],
        queryFn: async () => {
            const result: IHealthcareProfessional[] | undefined =
                await HealthcareProfessionalsApi.getHealthcareProfessionals();
            return result ? result.map((x) => new HealthcareProfessional(x)) : result;
        },
    });
}
